<template>
    
</template>
<script>
export default {
    created(){
        const workspaceId = this.$route.query.workspaceId 
        // console.log(workspaceId)
        localStorage.clear()
        this.$router.push(`/?workspaceId=${workspaceId}`)
    }
}
</script>
<style lang="scss" scoped>

</style>
